var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-4" }, [
    _vm.shouldShowTabs
      ? _c(
          "ul",
          { staticClass: "nav justify-content-center nav-tabs" },
          _vm._l(_vm.availableTabs, function(tab) {
            return _c(
              "li",
              {
                key: tab.name,
                staticClass: "nav-item",
                attrs: { role: "tablist" }
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "nav-link",
                    class: { active: _vm.selectedTab === tab.name },
                    attrs: {
                      href: "#" + tab.name,
                      "data-toggle": "tab",
                      role: "tab",
                      "aria-controls": tab.name,
                      "aria-selected": _vm.selectedTab === tab.name
                    },
                    on: {
                      click: function($event) {
                        return _vm.onTabSelected(tab.name)
                      }
                    }
                  },
                  [
                    _vm._v(" " + _vm._s(tab.text) + " "),
                    tab.name === "clarifications"
                      ? _c(
                          "span",
                          {
                            staticClass: "clarifications-count",
                            class: {
                              "font-weight-bold": _vm.hasUnreadClarifications
                            }
                          },
                          [_vm._v(_vm._s(_vm.clarificationsCount))]
                        )
                      : _vm._e()
                  ]
                )
              ]
            )
          }),
          0
        )
      : _vm._e(),
    _c("div", { staticClass: "tab-content" }, [
      _vm.problem
        ? _c(
            "div",
            {
              staticClass: "tab-pane fade py-4 p-lg-4",
              class: { "show active": _vm.selectedTab === "problems" }
            },
            [
              _c("omegaup-problem-settings-summary", {
                attrs: {
                  problem: _vm.problem,
                  "show-visibility-indicators": _vm.showVisibilityIndicators,
                  "show-edit-link": _vm.user.admin
                }
              }),
              _vm.problem.karel_problem
                ? _c("div", { staticClass: "karel-js-link my-3" }, [
                    _c(
                      "a",
                      {
                        staticClass: "p-3",
                        attrs: {
                          href:
                            "/karel.js/" +
                            (_vm.problem.sample_input
                              ? "#mundo:" + _vm.problem.sample_input
                              : ""),
                          target: "_blank"
                        }
                      },
                      [
                        _vm._v(" " + _vm._s(_vm.T.openInKarelJs) + " "),
                        _c("font-awesome-icon", {
                          attrs: { icon: ["fas", "external-link-alt"] }
                        })
                      ],
                      1
                    )
                  ])
                : _vm._e(),
              _c(
                "div",
                { staticClass: "mt-4 markdown" },
                [
                  _c("omegaup-markdown", {
                    ref: "statement-markdown",
                    attrs: {
                      markdown: _vm.problem.statement.markdown,
                      "source-mapping": _vm.problem.statement.sources,
                      "image-mapping": _vm.problem.statement.images,
                      "problem-settings": _vm.problem.settings
                    },
                    on: { rendered: _vm.onProblemRendered }
                  })
                ],
                1
              ),
              _c("hr", { staticClass: "my-3" }),
              _c("div", { staticClass: "font-italic" }, [
                _vm._v(
                  " " +
                    _vm._s(_vm.T.wordsSource + ": " + _vm.problem.source) +
                    " "
                )
              ]),
              _vm.problem.problemsetter
                ? [
                    _c(
                      "div",
                      [
                        _vm._v(" " + _vm._s(_vm.T.wordsProblemsetter) + ": "),
                        _c("omegaup-username", {
                          attrs: {
                            classname: _vm.problem.problemsetter.classname,
                            username: _vm.problem.problemsetter.username,
                            name: _vm.problem.problemsetter.name,
                            linkify: true
                          }
                        })
                      ],
                      1
                    ),
                    _c("div", [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.ui.formatString(_vm.T.wordsUploadedOn, {
                              date: _vm.time.formatDate(
                                _vm.problem.problemsetter.creation_date
                              )
                            })
                          ) +
                          " "
                      )
                    ]),
                    _vm._t("quality-nomination-buttons", [
                      _vm.visibilityOfPromotionButton
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link",
                                on: { click: _vm.onNewPromotion }
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.T.qualityNominationRateProblem) +
                                    " "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.user.loggedIn
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link",
                                attrs: { "data-report-problem-button": "" },
                                on: { click: _vm.onReportInappropriateProblem }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.T.wordsReportProblem) + " "
                                )
                              ]
                            )
                          ])
                        : _vm._e(),
                      _vm.user.reviewer && !_vm.nominationStatus.alreadyReviewed
                        ? _c("div", [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-link",
                                attrs: { "data-rate-problem-button": "" },
                                on: { click: _vm.onNewPromotionAsReviewer }
                              },
                              [
                                _vm._v(
                                  " " + _vm._s(_vm.T.reviewerNomination) + " "
                                )
                              ]
                            )
                          ])
                        : _vm._e()
                    ])
                  ]
                : _vm._e(),
              _vm.user.loggedIn
                ? _c("omegaup-overlay", {
                    attrs: {
                      "show-overlay":
                        _vm.currentPopupDisplayed !== _vm.PopupDisplayed.None
                    },
                    on: { "hide-overlay": _vm.onPopupDismissed },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "popup",
                          fn: function() {
                            return [
                              _c("omegaup-arena-runsubmit-popup", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentPopupDisplayed ===
                                      _vm.PopupDisplayed.RunSubmit,
                                    expression:
                                      "currentPopupDisplayed === PopupDisplayed.RunSubmit"
                                  }
                                ],
                                attrs: {
                                  "preferred-language": _vm.preferredLanguage,
                                  languages: _vm.filteredLanguages,
                                  "next-submission-timestamp":
                                    _vm.nextSubmissionTimestamp || new Date()
                                },
                                on: {
                                  dismiss: _vm.onPopupDismissed,
                                  "submit-run": _vm.onRunSubmitted
                                }
                              }),
                              _c("omegaup-arena-rundetails-popup", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentPopupDisplayed ===
                                      _vm.PopupDisplayed.RunDetails,
                                    expression:
                                      "currentPopupDisplayed === PopupDisplayed.RunDetails"
                                  }
                                ],
                                attrs: {
                                  data: _vm.currentRunDetailsData,
                                  "feedback-map": _vm.feedbackMap,
                                  "feedback-thread-map": _vm.feedbackThreadMap
                                },
                                on: { dismiss: _vm.onPopupDismissed },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "feedback",
                                      fn: function(data) {
                                        return [
                                          _vm._t("feedback", null, {
                                            feedback: data.feedback,
                                            guid: data.guid,
                                            isAdmin: data.admin
                                          })
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              }),
                              _c("omegaup-quality-nomination-promotion-popup", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentPopupDisplayed ===
                                      _vm.PopupDisplayed.Promotion,
                                    expression:
                                      "currentPopupDisplayed === PopupDisplayed.Promotion"
                                  }
                                ],
                                attrs: {
                                  solved:
                                    _vm.nominationStatus &&
                                    _vm.nominationStatus.solved,
                                  tried:
                                    _vm.nominationStatus &&
                                    _vm.nominationStatus.tried
                                },
                                on: {
                                  submit: function(request) {
                                    return _vm.$emit(
                                      "submit-promotion",
                                      request
                                    )
                                  },
                                  dismiss: function(
                                    qualityPromotionComponent,
                                    isDismissed
                                  ) {
                                    return _vm.onPopupPromotionDismissed(
                                      qualityPromotionComponent,
                                      isDismissed
                                    )
                                  }
                                }
                              }),
                              _c("omegaup-quality-nomination-demotion-popup", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentPopupDisplayed ===
                                      _vm.PopupDisplayed.Demotion,
                                    expression:
                                      "currentPopupDisplayed === PopupDisplayed.Demotion"
                                  }
                                ],
                                on: {
                                  dismiss: function($event) {
                                    _vm.currentPopupDisplayed =
                                      _vm.PopupDisplayed.None
                                  },
                                  submit: function(qualityDemotionComponent) {
                                    return _vm.$emit(
                                      "submit-demotion",
                                      qualityDemotionComponent
                                    )
                                  }
                                }
                              }),
                              _c("omegaup-quality-nomination-reviewer-popup", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value:
                                      _vm.currentPopupDisplayed ===
                                      _vm.PopupDisplayed.Reviewer,
                                    expression:
                                      "currentPopupDisplayed === PopupDisplayed.Reviewer"
                                  }
                                ],
                                attrs: {
                                  "allow-user-add-tags": _vm.allowUserAddTags,
                                  "level-tags": _vm.levelTags,
                                  "problem-level": _vm.problemLevel,
                                  "public-tags": _vm.publicTags,
                                  "selected-public-tags":
                                    _vm.selectedPublicTags,
                                  "selected-private-tags":
                                    _vm.selectedPrivateTags,
                                  "problem-alias": _vm.problem.alias,
                                  "problem-title": _vm.problem.title
                                },
                                on: {
                                  dismiss: function($event) {
                                    _vm.currentPopupDisplayed =
                                      _vm.PopupDisplayed.None
                                  },
                                  "rate-problem-as-reviewer": function(
                                    request
                                  ) {
                                    return _vm.$emit(
                                      "rate-problem-as-reviewer",
                                      request
                                    )
                                  }
                                }
                              })
                            ]
                          },
                          proxy: true
                        }
                      ],
                      null,
                      false,
                      2755689667
                    )
                  })
                : _vm._e(),
              _vm.problem.accepts_submissions
                ? [
                    _c(
                      "div",
                      { staticClass: "d-none d-sm-block" },
                      [
                        !_vm.problem.karel_problem
                          ? _c("omegaup-arena-ephemeral-grader", {
                              attrs: {
                                problem: _vm.problem,
                                "can-submit":
                                  _vm.user.loggedIn && !_vm.inContestOrCourse,
                                "accepted-languages": _vm.filteredLanguages,
                                "preferred-language": _vm.preferredLanguage,
                                "last-run": _vm.lastRun,
                                "next-submission-timestamp":
                                  _vm.nextSubmissionTimestamp || new Date(),
                                "next-execution-timestamp":
                                  _vm.nextExecutionTimestamp || new Date()
                              },
                              on: {
                                "execute-run": function() {
                                  return _vm.$emit("execute-run")
                                }
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "bg-white text-center p-4 d-sm-none border"
                      },
                      [_vm._v(" " + _vm._s(_vm.T.ephemeralGraderAlert) + " ")]
                    ),
                    !_vm.useNewVerdictTable
                      ? _c("omegaup-arena-runs", {
                          attrs: {
                            "problem-alias": _vm.problem.alias,
                            "contest-alias": _vm.contestAlias,
                            runs: _vm.runsByProblem,
                            "show-details": true,
                            "problemset-problems": [],
                            "request-feedback": _vm.requestFeedback,
                            "is-contest-finished": _vm.isContestFinished
                          },
                          on: {
                            "request-feedback": function(guid) {
                              return _vm.$emit("request-feedback", guid)
                            },
                            details: function(request) {
                              return _vm.onRunDetails(request, "problems")
                            },
                            "update-search-result-users-contest": function(
                              request
                            ) {
                              return _vm.$emit(
                                "update-search-result-users-contest",
                                request
                              )
                            },
                            "update-search-result-users": function(request) {
                              return _vm.$emit(
                                "update-search-result-users",
                                request
                              )
                            },
                            "new-submission": _vm.onNewSubmission
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "runs",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1443501107
                          )
                        })
                      : _c("omegaup-arena-runs-for-courses", {
                          attrs: {
                            "problem-alias": _vm.problem.alias,
                            "contest-alias": _vm.contestAlias,
                            runs: _vm.runsByProblem,
                            "show-details": true,
                            "problemset-problems": [],
                            "created-guid": _vm.createdGuid,
                            "next-submission-timestamp":
                              _vm.nextSubmissionTimestamp || new Date(),
                            "request-feedback": _vm.requestFeedback,
                            "is-contest-finished": _vm.isContestFinished
                          },
                          on: {
                            "request-feedback": function(guid) {
                              return _vm.$emit("request-feedback", guid)
                            },
                            details: function(request) {
                              return _vm.onRunDetails(request, "problems")
                            },
                            "update-search-result-users-contest": function(
                              request
                            ) {
                              return _vm.$emit(
                                "update-search-result-users-contest",
                                request
                              )
                            },
                            "update-search-result-users": function(request) {
                              return _vm.$emit(
                                "update-search-result-users",
                                request
                              )
                            },
                            "new-submission": _vm.onNewSubmission
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "title",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              },
                              {
                                key: "runs",
                                fn: function() {
                                  return [_c("div")]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            1443501107
                          )
                        })
                  ]
                : _vm._e(),
              _c("omegaup-problem-feedback", {
                attrs: {
                  "quality-histogram": _vm.parsedQualityHistogram,
                  "difficulty-histogram": _vm.parsedDifficultyHistogram,
                  "quality-score": _vm.histogramQuality,
                  "difficulty-score": _vm.histogramDifficulty
                }
              }),
              _vm._t("best-solvers-list", [
                _vm.problem.accepts_submissions
                  ? _c("omegaup-arena-solvers", {
                      attrs: { solvers: _vm.solvers }
                    })
                  : _vm._e()
              ])
            ],
            2
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "tab-pane fade p-4",
          class: { "show active": _vm.selectedTab === "runs" }
        },
        [
          !_vm.useNewVerdictTable
            ? _c("omegaup-arena-runs", {
                attrs: {
                  "show-all-runs": true,
                  runs: _vm.allRuns,
                  "show-details": true,
                  "show-user": true,
                  "show-rejudge": true,
                  "show-pager": true,
                  "show-disqualify": true,
                  "problemset-problems": [],
                  "search-result-users": _vm.searchResultUsers,
                  "search-result-problems": _vm.searchResultProblems,
                  "total-runs": _vm.totalRuns
                },
                on: {
                  details: function(request) {
                    return _vm.onRunDetails(request, "runs")
                  },
                  rejudge: function(run) {
                    return _vm.$emit("rejudge", run)
                  },
                  disqualify: function(run) {
                    return _vm.$emit("disqualify", run)
                  },
                  requalify: function(run) {
                    return _vm.$emit("requalify", run)
                  },
                  "filter-changed": function(request) {
                    return _vm.$emit("apply-filter", request)
                  },
                  "update-search-result-users-contest": function(request) {
                    return _vm.$emit(
                      "update-search-result-users-contest",
                      request
                    )
                  },
                  "update-search-result-problems": function(request) {
                    return _vm.$emit("update-search-result-problems", request)
                  },
                  "update-search-result-users": function(request) {
                    return _vm.$emit("update-search-result-users", request)
                  }
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "title",
                      fn: function() {
                        return [_c("div")]
                      },
                      proxy: true
                    },
                    {
                      key: "runs",
                      fn: function() {
                        return [_c("div")]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  1443501107
                )
              })
            : _c("omegaup-arena-runs-for-courses", {
                attrs: {
                  "show-all-runs": true,
                  runs: _vm.allRuns,
                  "show-details": true,
                  "show-user": true,
                  "show-rejudge": true,
                  "show-filters": true,
                  "show-disqualify": true,
                  "items-per-page": 100,
                  "problemset-problems": [],
                  "search-result-users": _vm.searchResultUsers,
                  "search-result-problems": _vm.searchResultProblems,
                  "total-runs": _vm.totalRuns
                },
                on: {
                  details: function(request) {
                    return _vm.onRunDetails(request, "runs")
                  },
                  rejudge: function(run) {
                    return _vm.$emit("rejudge", run)
                  },
                  disqualify: function(run) {
                    return _vm.$emit("disqualify", run)
                  },
                  requalify: function(run) {
                    return _vm.$emit("requalify", run)
                  },
                  "filter-changed": function(request) {
                    return _vm.$emit("apply-filter", request)
                  },
                  "update-search-result-users-contest": function(request) {
                    return _vm.$emit(
                      "update-search-result-users-contest",
                      request
                    )
                  },
                  "update-search-result-problems": function(request) {
                    return _vm.$emit("update-search-result-problems", request)
                  },
                  "update-search-result-users": function(request) {
                    return _vm.$emit("update-search-result-users", request)
                  }
                },
                scopedSlots: _vm._u([
                  {
                    key: "title",
                    fn: function() {
                      return [_c("div")]
                    },
                    proxy: true
                  },
                  {
                    key: "runs",
                    fn: function() {
                      return [_c("div")]
                    },
                    proxy: true
                  }
                ])
              }),
          _vm.user.loggedIn
            ? _c("omegaup-overlay", {
                attrs: {
                  "show-overlay":
                    _vm.currentPopupDisplayed !== _vm.PopupDisplayed.None
                },
                on: { "hide-overlay": _vm.onPopupDismissed },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "popup",
                      fn: function() {
                        return [
                          _c("omegaup-arena-rundetails-popup", {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  _vm.currentPopupDisplayed ===
                                  _vm.PopupDisplayed.RunDetails,
                                expression:
                                  "currentPopupDisplayed === PopupDisplayed.RunDetails"
                              }
                            ],
                            attrs: { data: _vm.currentRunDetailsData },
                            on: { dismiss: _vm.onPopupDismissed }
                          })
                        ]
                      },
                      proxy: true
                    }
                  ],
                  null,
                  false,
                  2110728485
                )
              })
            : _vm._e()
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "tab-pane fade p-4",
          class: { "show active": _vm.selectedTab === "clarifications" }
        },
        [
          _c("omegaup-arena-clarification-list", {
            attrs: {
              clarifications: _vm.currentClarifications,
              "in-contest": false,
              "is-admin": true
            },
            on: { "clarification-response": _vm.onClarificationResponse },
            scopedSlots: _vm._u([
              {
                key: "new-clarification",
                fn: function() {
                  return [_c("div")]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "tab-pane fade p-4",
          class: { "show active": _vm.selectedTab === "solution" }
        },
        [
          _c("omegaup-problem-solution", {
            attrs: {
              status: _vm.solutionStatus,
              "allowed-solutions-to-see": _vm.allowedSolutionsToSee,
              solution: _vm.solution
            },
            on: {
              "get-solution": function($event) {
                return _vm.$emit("get-solution")
              },
              "get-allowed-solutions": function($event) {
                return _vm.$emit("get-allowed-solutions")
              },
              "unlock-solution": function($event) {
                return _vm.$emit("unlock-solution")
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }